const NavBar = () => (
  <div className="navbar-container">
    <h1>Markdown Online Editor - React💜</h1>
    <ul className="buttons-default">
      <li>
        <a
          href="https://github.com/pranavkhapra/markdown-viewer"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://img.icons8.com/dusk/64/000000/github.png"
            alt="Github Icon"
          />
          <p>Github Repo</p>
        </a>
      </li>
      <li>
        <a
          href="https://www.pranavkhapra.tech/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://img.icons8.com/office/64/000000/globe.png"
            alt="portfolio link"
          />
          <p>Portfolio Site</p>
        </a>
      </li>
    </ul>
  </div>
);

export default NavBar;
